export default __webpack_public_path__ + "static/media/023-bonfire.788859bc.svg";